/**
 * @generated SignedSource<<279dbe1e9490f1d732d28de862a05cc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventCreateScreenComponent_storeCalendars$data = ReadonlyArray<{
  readonly id: string;
  readonly isExternal: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditComponent_storeCalendars">;
  readonly " $fragmentType": "CalendarTeamEventCreateScreenComponent_storeCalendars";
}>;
export type CalendarTeamEventCreateScreenComponent_storeCalendars$key = ReadonlyArray<{
  readonly " $data"?: CalendarTeamEventCreateScreenComponent_storeCalendars$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventCreateScreenComponent_storeCalendars">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CalendarTeamEventCreateScreenComponent_storeCalendars",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarTeamEventEditComponent_storeCalendars"
    }
  ],
  "type": "StoreCalendar",
  "abstractKey": null
};

(node as any).hash = "cf4b0c0293e7ab78b15b17cd5a898134";

export default node;
